import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  container: {
    padding: 8
  },
  select: {
    display: 'flex',
    padding: 10,
    borderRadius: 6,
    cursor: 'pointer',
    '&:hover': {
      background: '#f7f7f8'
    }
  },
  label: {
    marginLeft: 10,
    fontSize: 14,
    fontWeight: 400
  },
  sectionTitle: {
    color: '#6A728F',
    fontSize: 12,
    marginTop: 4,
    marginLeft: 12,
    marginBottom: 10
  }
}));

export type AuditType = {
  uuid: string;
  name: string;
};

type State = {
  auditTypeUUIDs: string[];
};

type Props = {
  onChange: (state: State) => void;
  state: State;
  auditTypes?: AuditType[];
};

// created -> application -> responses -> approved

export default function FilterOptions({ state, auditTypes, onChange }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.sectionTitle}>AUDIT TYPES</div>
      {auditTypes?.map((auditType) => (
        <div
          key={auditType.uuid}
          className={classes.select}
          onClick={() => {
            let newIds = [...state.auditTypeUUIDs];

            if (state.auditTypeUUIDs.includes(auditType.uuid)) {
              // Remove if already in there
              const i = newIds.findIndex((id) => id === auditType.uuid);
              newIds.splice(i, 1);
            } else {
              // Otherwise add it
              newIds.push(auditType.uuid);
            }
            onChange({
              auditTypeUUIDs: newIds
            });
          }}
        >
          <input
            type="checkbox"
            checked={state.auditTypeUUIDs.includes(auditType.uuid)}
          />
          <div className={classes.label}>{auditType.name}</div>
        </div>
      ))}
    </div>
  );
}
